import * as React from 'react';

export interface IGridHeaderColumnProps {
    title : string;
    cssClasses : string;
    visible : boolean;
}

export const GridHeaderColumn = (props : IGridHeaderColumnProps) => {
    return <div 
        className={"mijn-fnv-grid__column mijn-fnv-grid__header-column d-none d-md-flex " + props.cssClasses + " "  + (props.visible ? "" : "hidden")}>
        <span>
        <strong>{props.title}</strong>
        </span>
    </div>;
};